<template>

<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg2589"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs2593"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath2603"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path2601" /></clipPath></defs><g
     id="g2595"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g2597"><g
         id="g2599"
         clip-path="url(#clipPath2603)"><g
           id="g2605"
           transform="translate(139.3286,172.7422)"><path
             d="m 0,0 c 0,-24.233 -19.645,-43.878 -43.877,-43.878 -24.233,0 -43.877,19.645 -43.877,43.878 0,24.232 19.644,43.877 43.877,43.877 C -19.645,43.877 0,24.232 0,0 Z"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2607" /></g><g
           id="g2609"
           transform="translate(432.7031,172.7422)"><path
             d="m 0,0 c 0,-24.233 -19.645,-43.878 -43.878,-43.878 -24.232,0 -43.877,19.645 -43.877,43.878 0,24.232 19.645,43.877 43.877,43.877 C -19.645,43.877 0,24.232 0,0 Z"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2611" /></g><g
           id="g2613"
           transform="translate(287.8154,172.7451)"><path
             d="m 0,0 h 57.135 c 0,24.23 19.639,43.87 43.88,43.87 24.23,0 43.87,-19.64 43.87,-43.87 h 56.349 l 12.951,22.65 v 18.951 c 0,4.639 -0.55,9.25 -1.621,13.729 -3.729,16.16 -14.96,30.82 -28.11,40.46 -8.239,6.061 -17.689,10.49 -27.859,12.92 l -61.09,14.65 -54.11,55.15 c -20.02,20.39 -47.39,31.881 -75.97,31.881 h -76 -118.691 l 11.898,-14.785 c 4.2,-5.217 3.521,-12.821 -1.536,-17.212 L -270.266,133.79 V 76.601 L -277.815,62.37 V 22.65 L -262.706,0 h 26.46 c 0,24.23 19.65,43.87 43.881,43.87 24.23,0 43.88,-19.64 43.88,-43.87 h 60.495"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2615" /></g><g
           id="g2617"
           transform="translate(500.2803,228.4648)"><path
             d="m 0,0 h -41.2 c -3.981,0 -7.59,1.62 -10.2,4.23 -2.621,2.611 -4.23,6.21 -4.23,10.201 0,4.91 2.489,9.49 6.619,12.139 l 21,13.5 C -14.825,30.4 -3.937,16.083 0,0 Z"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2619" /></g><g
           id="g2621"
           transform="translate(326.6562,284.2559)"><path
             d="m 0,0 c -40.628,3.215 -202.201,16.391 -241.393,19.588 -3.292,0.268 -4.689,4.322 -2.266,6.567 l 35.59,32.972 c 2.194,2.033 5.074,3.162 8.066,3.162 h 118.934 c 22.282,0 43.484,-9.6 58.184,-26.345 L 3.148,6.288 C 5.396,3.728 3.396,-0.27 0,0 Z"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2623" /></g><g
           id="g2625"
           transform="translate(216.3335,346.5449)"><path
             d="M 0,0 V -53.376"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2627" /></g><g
           id="g2629"
           transform="translate(216.3335,246.5)"><path
             d="M 0,0 H 22.365"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2631" /></g><g
           id="g2633"
           transform="translate(81.9565,260.3994)"><path
             d="M 0,0 H 22.366"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2635" /></g><g
           id="g2637"
           transform="translate(244.814,172.7422)"><path
             d="M 0,0 V 0"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2639" /></g></g></g></g></svg>
</template>
